module.exports = "/images/amex.svg?16b78605507c823aa8acd4ec5ec304e5";